export const Channel={ 
      "EMAIL"     : 10
    , "WHATSAPP"  : 20
    , "SMS"       : 30
    , "NOTIF"     : 40
    , "IVR"       : 50
}